var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "button raised secondary",
      attrs: { href: "/oidcauthenticate/" }
    },
    [
      _c(
        "svg",
        {
          attrs: {
            role: "presentation",
            viewBox: "0 0 256 256",
            "xmlns:svg": "http://www.w3.org/2000/svg",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
            width: "128",
            height: "128",
            id: "svg2"
          }
        },
        [
          _c("title", { attrs: { id: "title2910" } }, [_vm._v("facebook web")]),
          _c(
            "defs",
            { attrs: { id: "defs4" } },
            [
              _c("inkscape:perspective", {
                attrs: {
                  "sodipodi:type": "inkscape:persp3d",
                  "inkscape:vp_x": "0 : 128 : 1",
                  "inkscape:vp_y": "0 : 1000 : 0",
                  "inkscape:vp_z": "256 : 128 : 1",
                  "inkscape:persp3d-origin": "128 : 85.333333 : 1",
                  id: "perspective17"
                }
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    "inkscape:collect": "always",
                    id: "linearGradient2555"
                  }
                },
                [
                  _c("stop", {
                    staticStyle: {
                      "stop-color": "rgb(255, 255, 255)",
                      "stop-opacity": "1"
                    },
                    attrs: { offset: "0", id: "stop2557" }
                  }),
                  _c("stop", {
                    staticStyle: {
                      "stop-color": "rgb(255, 255, 255)",
                      "stop-opacity": "0"
                    },
                    attrs: { offset: "1", id: "stop2559" }
                  })
                ],
                1
              ),
              _c("linearGradient", {
                attrs: {
                  "inkscape:collect": "always",
                  "xlink:href": "#linearGradient2555",
                  id: "linearGradient2449",
                  gradientUnits: "userSpaceOnUse",
                  gradientTransform:
                    "matrix(-0.5914584,0,0,0.5914584,210.02161,142.23241)",
                  x1: "-344.15295",
                  y1: "274.711",
                  x2: "-395.84943",
                  y2: "425.39993"
                }
              })
            ],
            1
          ),
          _c("sodipodi:namedview", {
            attrs: {
              id: "base",
              pagecolor: "#ffffff",
              bordercolor: "#666666",
              borderopacity: "1.0",
              "inkscape:pageopacity": "0.0",
              "inkscape:pageshadow": "2",
              "inkscape:zoom": "0.24748737",
              "inkscape:cx": "-276.99783",
              "inkscape:cy": "104.86584",
              "inkscape:document-units": "px",
              "inkscape:current-layer": "layer1",
              "inkscape:window-width": "712",
              "inkscape:window-height": "762",
              "inkscape:window-x": "1",
              "inkscape:window-y": "193",
              showgrid: "false",
              "inkscape:window-maximized": "0"
            }
          }),
          _c(
            "metadata",
            { attrs: { id: "metadata7" } },
            [
              _c(
                "rdf:RDF",
                [
                  _c(
                    "cc:Work",
                    { attrs: { "rdf:about": "" } },
                    [
                      _c("dc:format", [_vm._v("image/svg+xml")]),
                      _c("dc:type", {
                        attrs: {
                          "rdf:resource":
                            "http://purl.org/dc/dcmitype/StillImage"
                        }
                      }),
                      _c("dc:title", [_vm._v("facebook web")]),
                      _c(
                        "dc:creator",
                        [
                          _c(
                            "cc:Agent",
                            [_c("dc:title", [_vm._v("User:ZyMOS")])],
                            1
                          )
                        ],
                        1
                      ),
                      _c("dc:subject", [_c("rdf:Bag")], 1),
                      _c("cc:license", {
                        attrs: {
                          "rdf:resource":
                            "http://creativecommons.org/licenses/publicdomain/"
                        }
                      }),
                      _c("dc:description"),
                      _c(
                        "dc:contributor",
                        [_c("cc:Agent", [_c("dc:title")], 1)],
                        1
                      ),
                      _c(
                        "dc:publisher",
                        [
                          _c(
                            "cc:Agent",
                            [_c("dc:title", [_vm._v("Open Icon Library")])],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "cc:License",
                    {
                      attrs: {
                        "rdf:about":
                          "http://creativecommons.org/licenses/publicdomain/"
                      }
                    },
                    [
                      _c("cc:permits", {
                        attrs: {
                          "rdf:resource":
                            "http://creativecommons.org/ns#Reproduction"
                        }
                      }),
                      _c("cc:permits", {
                        attrs: {
                          "rdf:resource":
                            "http://creativecommons.org/ns#Distribution"
                        }
                      }),
                      _c("cc:permits", {
                        attrs: {
                          "rdf:resource":
                            "http://creativecommons.org/ns#DerivativeWorks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "g",
            {
              attrs: {
                "inkscape:label": "Layer 1",
                "inkscape:groupmode": "layer",
                id: "layer1",
                transform: "translate(-373.642,-318.344)"
              }
            },
            [
              _c("rect", {
                staticStyle: {
                  fill: "#ebebee",
                  "fill-opacity": "1",
                  "fill-rule": "evenodd",
                  stroke: "#000000",
                  "stroke-width": "0.5",
                  "stroke-linecap": "square",
                  "stroke-linejoin": "miter",
                  "stroke-miterlimit": "4",
                  "stroke-dasharray": "0.5,1",
                  "stroke-dashoffset": "0",
                  "stroke-opacity": "1"
                },
                attrs: {
                  "inkscape:export-ydpi": "7.7063322",
                  "inkscape:export-xdpi": "7.7063322",
                  "inkscape:export-filename":
                    "C:\\Documents and Settings\\Molumen\\Desktop\\path3511111.png",
                  transform: "scale(-1,1)",
                  ry: "35.487503",
                  rx: "35.487503",
                  y: "328.34399",
                  x: "-619.64203",
                  height: "236",
                  width: "236",
                  id: "rect1942"
                }
              }),
              _c("path", {
                staticStyle: {
                  opacity: "0.98283262",
                  fill: "url(#linearGradient2449)",
                  "fill-opacity": "1",
                  "fill-rule": "evenodd",
                  stroke: "none",
                  "stroke-width": "0.87500000000000000",
                  "stroke-linecap": "square",
                  "stroke-linejoin": "miter",
                  "stroke-miterlimit": "4",
                  "stroke-dasharray":
                    "0.87500000000000000, 1.75000000000000000",
                  "stroke-dashoffset": "0",
                  "stroke-opacity": "1"
                },
                attrs: {
                  "inkscape:export-ydpi": "7.7063322",
                  "inkscape:export-xdpi": "7.7063322",
                  "inkscape:export-filename":
                    "C:\\Documents and Settings\\Molumen\\Desktop\\path3511111.png",
                  "sodipodi:nodetypes": "ccccsssc",
                  id: "path1950",
                  d:
                    "M 557.29062,338.43314 L 445.99327,338.43314 C 416.53255,338.43314 392.81507,362.34527 392.81507,392.04777 L 392.81507,500.64007 C 393.76867,523.8254 397.43678,509.16812 404.41887,483.49194 C 412.53354,453.65102 438.96056,427.56963 471.144,408.02312 C 495.7086,393.10398 523.20395,383.5772 573.25282,382.6709 C 601.63697,382.15694 599.13112,345.83025 557.29062,338.43314 z"
                }
              }),
              _c("path", {
                staticStyle: {
                  fill: "#ff8e00",
                  "fill-opacity": "1",
                  stroke: "none"
                },
                attrs: {
                  d:
                    "m 488.0825,538.40564 26.93006,-19.41471 -1.2525,-154.06511 -25.67756,20.04099 0,153.43883 z",
                  id: "path25468"
                }
              }),
              _c("path", {
                staticStyle: {
                  fill: "#626262",
                  "fill-opacity": "1",
                  stroke: "none"
                },
                attrs: {
                  d:
                    "M 488.39564,538.40564 C 387.66591,522.39153 384.79535,434.69468 487.76935,415.65457 l 0.31315,18.16215 c -73.04418,12.17854 -63.78999,77.70661 0,87.36619 l 0.31314,17.22273 z",
                  id: "path25470",
                  "sodipodi:nodetypes": "ccccc"
                }
              }),
              _c("path", {
                staticStyle: {
                  fill: "#626262",
                  "fill-opacity": "1",
                  stroke: "none"
                },
                attrs: {
                  d:
                    "m 514.69946,433.19044 c 12.45669,0.0847 23.30841,5.78683 34.13233,11.58619 l -15.97017,11.89934 51.04191,0 0.3131,-34.75859 -15.97018,11.89934 c -16.16175,-8.16308 -31.01691,-17.95941 -53.54699,-18.16215 l 0,17.53587 z",
                  id: "path25472",
                  "sodipodi:nodetypes": "cccccccc"
                }
              })
            ]
          )
        ],
        1
      ),
      _c("div", [_vm._v(_vm._s(_vm.$tr("signInWithOpenIDConnect")))])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }